import { render, staticRenderFns } from "./employment.vue?vue&type=template&id=39f9bf1a&scoped=true"
import script from "./employment.vue?vue&type=script&lang=js"
export * from "./employment.vue?vue&type=script&lang=js"
import style0 from "./employment.vue?vue&type=style&index=0&id=39f9bf1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f9bf1a",
  null
  
)

export default component.exports